import {
  HOME_HIDE_PROJECT_WELCOME_POPUP_BEGIN,
  HOME_HIDE_PROJECT_WELCOME_POPUP_SUCCESS,
  HOME_HIDE_PROJECT_WELCOME_POPUP_FAILURE,
  HOME_HIDE_PROJECT_WELCOME_POPUP_DISMISS_ERROR,
} from './constants';
import axios from 'axios';

export function hideProjectWelcomePopup(args = {}) {
  return (dispatch) => {
    dispatch({
      type: HOME_HIDE_PROJECT_WELCOME_POPUP_BEGIN,
    });
    const { projectId, version } = args;
    const promise = new Promise((resolve, reject) => {
      const doRequest = axios.put(
        `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/projects/${projectId}/update`,
        args.data,
      );
      doRequest.then(
        (res) => {
          dispatch({
            type: HOME_HIDE_PROJECT_WELCOME_POPUP_SUCCESS,
            data: res.data,
          });
          resolve(res);
        },
        (err) => {
          dispatch({
            type: HOME_HIDE_PROJECT_WELCOME_POPUP_FAILURE,
            data: { error: err },
          });
          reject(err);
        },
      );
    });

    return promise;
  };
}

export function dismissHideProjectWelcomePopupError() {
  return {
    type: HOME_HIDE_PROJECT_WELCOME_POPUP_DISMISS_ERROR,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case HOME_HIDE_PROJECT_WELCOME_POPUP_BEGIN:
      return {
        ...state,
        hideProjectWelcomePopupPending: true,
        hideProjectWelcomePopupError: null,
      };

    case HOME_HIDE_PROJECT_WELCOME_POPUP_SUCCESS:
      return {
        ...state,
        hideProjectWelcomePopupPending: false,
        hideProjectWelcomePopupError: null,
        projectDetail: action.data,
        showProjectWelcomePopup: false,
      };

    case HOME_HIDE_PROJECT_WELCOME_POPUP_FAILURE:
      return {
        ...state,
        hideProjectWelcomePopupPending: false,
        hideProjectWelcomePopupError: action.data.error,
      };

    case HOME_HIDE_PROJECT_WELCOME_POPUP_DISMISS_ERROR:
      return {
        ...state,
        hideProjectWelcomePopupError: null,
      };

    default:
      return state;
  }
}
